// extracted by mini-css-extract-plugin
module.exports = {"PageHeader":"ModerationPage_PageHeader__1H9lZ"};